import { topics } from '@/mocks/home';

const topicColors = [
  'bg-primary-100 text-primary-700 hover:bg-primary-200',
  'bg-accent-100 text-accent-700 hover:bg-accent-200',
  'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-chat-1-line text-xs"></i>
            <span>话题热榜</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            漫迷都在讨论的热门话题，加入社区一起畅聊
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topics.map((topic, i) => (
              <div
                key={topic.name}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all hover:scale-105 ${
                  topicColors[i % topicColors.length]
                }`}
              >
                <span className="text-sm font-medium whitespace-nowrap">#{topic.name}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{topic.count}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-foreground-400">
              话题持续更新中，更多精彩讨论等你发现
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}